<main>
    <div *ngIf="pageContent" class="apple-certificate-info">
        <h1>{{pageContent.heading}}</h1>
        <div *ngIf='initModal'>
          <app-modal [showModal]="initModal" [modalClass]="modalClass">
            <app-confirm-modal [modalPopupObject]='confirmModalPopup' [triggerElement]='eventEmit' (modalOutput)="closeModal($event)">
            </app-confirm-modal>
          </app-modal>
        </div>
        
        <div class="row">
          <div *ngIf="notiContent.type" class="alert valign-children-middle error-container">
            <div class="alert-{{notiContent.type}}" role="img" aria-label="Error">
              <i attr.aria-label="{{pageContent[notiContent.type+'Msg'][notiContent.content].AccessibilityText}}" [ngClass]="{'icon-badgealert': notiContent.type === 'error', 'icon-approval': notiContent.type === 'success'}"></i>
            </div>
            <div>
              <h3>{{pageContent[notiContent.type+'Msg'][notiContent.content].header}}</h3>
              <span class="message">{{pageContent[notiContent.type+'Msg'][notiContent.content].msg}}</span>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="appleCertificateSummary && appleCertificateSummary.status === 'Processing'">
          <div class="alert valign-children-middle error-container">
            <div class="alert-info">
              <i class="icon-flat-info" role="img" aria-label="Info"></i>
            </div>
            <div>
              <h3 class="alert-heading">{{pageContent.processing.header}}</h3>
              <span class="message">{{pageContent.processing.msg}}</span>
            </div>
          </div>
        </div>
        <div *ngIf="appleCertificateSummary">
          <div class="row">
            <p *ngIf="useMock">
              Scenarios for Demo: <select id="scenariosSelect" #scenariosSelect (change)="scenarioChange(scenariosSelect.value);">
              <option value="1">Not Installed</option>
              <option value="2">Installed</option>
              <option value="3">Expired</option>
              <option value="4">Processing</option>
            </select>
            </p>      
            <p>
              <span *ngIf="appleCertificateSummary.status !== 'Expired' && appleCertificateSummary.status !== 'Nearing expiration'" [innerHtml]="pageContent.descriptionWithModal.pageDescription"></span> 
              <span *ngIf="appleCertificateSummary.status === 'Expired'" [innerHtml]="pageContent.descriptionWithModal.pageDescriptionExpired"></span> 
              <span *ngIf="appleCertificateSummary.status === 'Nearing expiration' && !renewAppleCertificate">{{pageContent.descriptionWithModal.pageDescriptionNearingExpiration[0]}}.</span> 
              <span *ngIf="appleCertificateSummary.status === 'Nearing expiration' && renewAppleCertificate"> {{pageContent.descriptionWithModal.pageDescriptionNearingExpiration[0]}}{{pageContent.descriptionWithModal.pageDescriptionNearingExpiration[1]}}.</span> 
              <!-- <a href="javascript:void(0);" (click)="confirmModal(pageContent.popupContent.learnMore, false)">
                {{pageContent.descriptionWithModal.pageDescription[1]}}
              </a>
              {{pageContent.descriptionWithModal.pageDescription[2]}} -->
            </p>
            <div class="applecertificate-status" *ngIf="appleCertificateSummary.status === 'Not Installed'">
              <i class="icon-alert ico" role="img" aria-label="Alert"></i>
              <span [innerHtml]="pageContent.status[appleCertificateSummary.status]"></span>
            </div>
      
            <div *ngIf="appleCertificateSummary.status !== 'Not Installed' && !renewAppleCertificate" class="apple-certificate-summary">
      
              <p class="status-list">
                <label class="label-block" [innerHtml]="pageContent.status[appleCertificateSummary.status]"></label>
                <span *ngIf="appleCertificateSummary.status !=='Nearing expiration'" [ngClass]="appleCertificateSummary.status" >{{appleCertificateSummary.status}}</span>
                <span *ngIf="appleCertificateSummary.status ==='Nearing expiration'" class="nearingExpiration" >{{appleCertificateSummary.status}} <a href="javascript:void(0)" (click)="renewAppleCert()" >Renew</a></span>
              </p>
              <p class="status-list">
                <label class="label-block">{{pageContent.certificateInfo.appleId}}</label>
                <span>{{appleCertificateSummary.info.appleId}}</span>
              </p>
              <p class="status-list">
                <label class="label-block">{{pageContent.certificateInfo.serialNumber}}</label>
                <span>{{appleCertificateSummary.info.serialNumber}}</span>
              </p>
              <p class="status-list">
                <label class="label-block">{{pageContent.certificateInfo.validFrom}}</label>
                <span>{{appleCertificateSummary.info.validFrom}}</span>
              </p>
              <p class="status-list">
                <label class="label-block">{{pageContent.certificateInfo.expiredOn}}</label>
                <span>{{appleCertificateSummary.info.expiredOn}}</span>
              </p>
              <p class="status-list">
                <label class="label-block">{{pageContent.certificateInfo.installedOn}}</label>
                <span>{{appleCertificateSummary.info.installedOn}}</span>
              </p>
              <p class="status-list">
                <label class="label-block">{{pageContent.certificateInfo.appliesTo}}</label>
                <span>{{appleCertificateSummary.info.appliesTo}}</span>
              </p>
              <p *ngIf="appleCertificateSummary.status === 'Expired'" class="status-list">{{pageContent.descriptionWithModal.removeAppleCertificateExpired[0]}} <a href="javascript:void(0);" (click)="confirmModal(pageContent.popupContent.removeCertificate, true)">{{pageContent.descriptionWithModal.removeAppleCertificateExpired[1]}}</a>{{pageContent.descriptionWithModal.removeAppleCertificateExpired[2]}}</p>
              <div *ngIf="appleCertificateSummary.status === 'Nearing expiration'" class="status-list">
                <p>{{pageContent.descriptionWithModal.verifyAccess[0]}} <a  target="_blank" href="https://identity.apple.com/pushcert">{{pageContent.descriptionWithModal.verifyAccess[1]}}</a></p>
                <p>{{pageContent.descriptionWithModal.removeAppleCertificateNearingExpiration[0]}} <a href="javascript:void(0);" (click)="confirmModal(pageContent.popupContent.removeCertificate, true)">{{pageContent.descriptionWithModal.removeAppleCertificateNearingExpiration[1]}}</a></p>
              </div>
              <p *ngIf="appleCertificateSummary.status !== 'Expired' && appleCertificateSummary.status !== 'Nearing expiration'" class="status-list">{{pageContent.descriptionWithModal.removeAppleCertificate[0]}} <a href="javascript:void(0);" (click)="confirmModal(pageContent.popupContent.removeCertificate, true)">{{pageContent.descriptionWithModal.removeAppleCertificate[1]}}</a>{{pageContent.descriptionWithModal.removeAppleCertificate[2]}}</p>
            </div>     
            
          </div>
          <div *ngIf="appleCertificateSummary.status === 'Not Installed' || renewAppleCertificate">
              <h2>{{pageContent.installHeading}}</h2>
          <div class="row">
            <app-accordion [accordion]="accordionList" [accordionController]=false>
              <app-accordion-list *ngFor="let acc of accordionList; let i = index" [option]='acc' [isSubAccordion]=true>
      
                <div class="apple-content">
                  <p>
                    {{pageContent.whatToExpectDescription}}
                  </p>
                  <h3> {{pageContent.step1.heading}}</h3>
                  <ul>
                    <li *ngFor="let st of pageContent.step1.steps">{{st}}</li>
                  </ul>
                  <h3> {{pageContent.step2.heading}}</h3>
                  <ul>
                    <li *ngFor="let st of pageContent.step2.steps">{{st}}</li>
                  </ul>
                </div>
              </app-accordion-list>
            </app-accordion>
            <div class="appleid-section">
             <div *ngIf="appleCertificateSummary.status !== 'Nearing expiration'"><h3 >{{pageContent.step1.active}}</h3></div>
              <p *ngIf="appleCertificateSummary.status !== 'Nearing expiration'"> <span [innerHtml]="pageContent.descriptionWithModal.step1description[0]"></span><a target="_blank" href="https://identity.apple.com/pushcert">{{pageContent.descriptionWithModal.step1description[1]}} </a>        {{pageContent.descriptionWithModal.step1description[2]}}
              </p>
              <p *ngIf="appleCertificateSummary.status === 'Nearing expiration'"> <span [innerHtml]="pageContent.descriptionWithModal.step1descriptionNearingExpiration[0]"></span><a target="_blank" href="https://identity.apple.com/pushcert">{{pageContent.descriptionWithModal.step1descriptionNearingExpiration[1]}} </a>
              </p>
              <div>
              <p>Company Id:  {{user.companyId }}</p>
             </div>
              <div class="col-sm-12 col-md-12 apple-id">
                <label [ngClass]="{'error-msg': notiContent.content === 'invalidAppId'}" class="label-block">{{pageContent.labelAppleId}}</label>
              </div>
              <div class="col-sm-9 col-md-5 apple-id">
                <div [ngClass]="{'appleid-field': notiContent.content !== 'invalidAppId'}">
                  <input id="inputAppleid" #inputAppleid (change)="resetErrorMessage(inputAppleid.value)" (keydown)="resetErrorMessage(inputAppleid.value)"  
                  [ngClass]="{'text-error': notiContent.content === 'invalidAppId'}" type="text" class="form-control"
                    attr.aria-label="{{pageContent.labelAppleId}}" [disabled]="appleCertificateSummary.status === 'Nearing expiration'">
                </div>
                <p class="error-msg" *ngIf="notiContent.content === 'invalidAppId'"> <i class="icon-badgealert"> </i>{{pageContent.errorMsg.invalidAppId.inputErr}}</p>
                <div class="csr-link" *ngIf="csrAvailable">
                  <a href="javascript:void(0)" (click)="navigateToStepTwo()">{{pageContent.skipStep1}}</a>
                </div>
              </div>
            </div>
          </div>
          <hr/>
          <div class="row cancel-button">
            <div class="col-sm-12 col-md-12 text-right">
              <button [disabled]="isDisabled" [checkImpersonator]= "appleId === '' || notiContent.type === 'error'"(click)="generateCSR(inputAppleid.value)" class="btn btn-secondary pull-right"
                attr.aria-label="{{pageContent.buttons.AccessibilityText}}"> {{pageContent.buttons.submit}}  </button>
              <a href="javascript:void(0)" class="btn btn-link btn-block btn-cancel" attr.aria-label="{{pageContent.buttons.cancel}}" (click)="onclickOfCancel()"> {{pageContent.buttons.cancel}}  </a>
            </div>
          </div>
        </div>
        </div>
      </div>
</main>
